// extracted by extract-css-chunks-webpack-plugin
module.exports = {"error-container":"oW12f5l6TIhdmxDW5Ieq"};